import { useMemo } from 'react';
import { useEditor } from '../../context/EditorContext';
import { useCart, calculateItemPrice, calculateCartTotals } from '../../context/CartContext';
import { TSHIRT_COLORS } from '../../config/productImages';

// Builds the checkout item list (current design + cart items) and order totals
export const useCheckoutItems = (initialQuantity) => {
  const { color, size, getAllDesigns, hasAnyDesign } = useEditor();
  const { cartItems } = useCart();

  const currentDesigns = useMemo(() => getAllDesigns(), [getAllDesigns]);
  const hasCurrentDesign = hasAnyDesign();
  const currentItemPrice = calculateItemPrice(currentDesigns);

  const currentItem = useMemo(() => {
    if (!hasCurrentDesign) return null;
    const colorInfo = TSHIRT_COLORS.find(c => c.hex === color) || { name: 'Custom' };
    return {
      id: 'current',
      color,
      colorName: colorInfo.name,
      size,
      designs: currentDesigns,
      quantity: initialQuantity,
      unitPrice: calculateItemPrice(currentDesigns),
      isCurrent: true,
    };
  }, [hasCurrentDesign, color, size, currentDesigns, initialQuantity]);

  const displayItems = useMemo(
    () => (currentItem ? [currentItem, ...cartItems] : [...cartItems]),
    [currentItem, cartItems]
  );

  const orderTotals = useMemo(() => calculateCartTotals(displayItems), [displayItems]);

  return {
    displayItems,
    orderTotals,
    totalPrice: orderTotals.total,
    currentDesigns,
    currentItemPrice,
    hasCurrentDesign,
    cartCount: cartItems.length,
  };
};

export default useCheckoutItems;
